import { CourseEnrollmentHistoryResponse } from '@/types/views/learningHistory.types';
import { useAppQuery } from './useAppQuery';

/**
 * Per-enrolment learning-history timeline for the Manage > Training drilldown.
 * Course enrolments query by `courseEnrollmentId`; learning-path enrolments use their own
 * `learningPathEnrollmentId` against the learning-paths history endpoint; enrolments from the
 * organisation's own LearnUpon portal use `integrationEnrollmentId` against the integrations one.
 * The query stays disabled until one of those ids is available.
 */
export const useCourseEnrollmentHistory = (
  {
    courseEnrollmentId,
    learningPathEnrollmentId,
    integrationEnrollmentId,
  }: {
    courseEnrollmentId?: string | null;
    learningPathEnrollmentId?: string | null;
    integrationEnrollmentId?: string | null;
  },
  enabled = true
) => {
  const url = learningPathEnrollmentId
    ? `/TrainingManager/learningpaths/enrollments/${learningPathEnrollmentId}/history`
    : courseEnrollmentId
      ? `/TrainingManager/courses/enrollments/${courseEnrollmentId}/history`
      : `/TrainingManager/integrations/enrollments/${integrationEnrollmentId}/history`;

  return useAppQuery<CourseEnrollmentHistoryResponse>(url, {
    enabled:
      enabled && !!(learningPathEnrollmentId || courseEnrollmentId || integrationEnrollmentId),
  });
};
